export default __webpack_public_path__ + "static/media/mobile-app.a31aebb1.jpg";